import { createTheme } from '@mui/material/styles';
import { white, lightBlue, black, gray, darkBlue } from './Constants/Colors';

import AptosRegularTTF from './Resources/Fonts/Aptos.ttf';
import AptosItalicTTF from './Resources/Fonts/Aptos-Italic.ttf';
import AptosBoldTTF from './Resources/Fonts/Aptos-Bold.ttf';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 400,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },

  palette: {
    primary: {
      light: lightBlue,
      main: lightBlue,
      dark: darkBlue,
      contrastText: white
    }
  },
  typography: {
    fontFamily: '"Aptos", Arial, serif',
    allVariants: {
      color: black
    },
    h1: {
      fontSize: '26px'
    },
    h2: {
      fontSize: '26px',
      fontWeight: 'bold'
    },
    h3: {
      fontSize: '16px'
    },
    h4: {
      fontSize: '14px'
    }
  },
  shape: {
    borderRadius: 0
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Aptos';
          font-style: normal;
          font-display: swap;
          font-weight: 100 400;
          src: local('Aptos'), local('Aptos-Regular'), url(${AptosRegularTTF}) format('truetype');
        }
        @font-face {
          font-family: 'Aptos';
          font-style: italic;
          font-display: swap;
          font-weight: 100 400;
          src: local('Aptos'), local('Aptos-Italic'), url(${AptosItalicTTF}) format('truetype');
        }
        @font-face {
          font-family: 'Aptos';
          font-style: normal;
          font-display: swap;
          font-weight: 500 1000;
          src: local('Aptos'), local('Aptos-Regular'), url(${AptosBoldTTF}) format('truetype');
        }
      `
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: '14px'
        },
        input: {
          padding: '8px 12px'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          textTransform: 'none',
          boxShadow: 'none',
          height: '48px',
          fontWeight: 'normal',
          fontSize: '18px',
          [theme.breakpoints.down('sm')]: {
            fontSize: '14px'
          }
        })
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: gray,
          color: black
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          background: 'transparent',
          textTransform: 'none',
          fontSize: '20px',
          fontWeight: 'normal',
          borderRadius: '5px 5px 0 0',
          color: darkBlue,
          '&.Mui-selected': {
            backgroundColor: darkBlue,
            color: white
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${black}`,
          padding: '0 16px'
        },
        indicator: {
          display: 'none'
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: black
        }
      }
    }
  }
});

export default theme;
